module.exports = __webpack_public_path__ + "static/media/leia-organa.4b2bd907.jpg";